import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import CircularProgress from "@material-ui/core/CircularProgress";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import {Link} from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";



const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));




export default function FornecedorListar() {
    const classes = useStyles();

    const [fornecedores, setFornecedores] = useState([]);
    const [lista, setLista] = useState([]);
    const [loading, setLoading] = React.useState(false);
    const [inativos, setInativos] = React.useState(false);

    useEffect(()=>{
        setLoading(true)
            api.get('/fornecedor').then(res=>{
                if(res.data.code===0){
                    const data=[];
                    for (let row of res.data.data){
                        data.push(row)
                    }
                    setFornecedores(data)
                    setLista(data)
                }
                setLoading(false)
            })

    }, [inativos])

    function pesquisa(e) {
        // eslint-disable-next-line array-callback-return
        let temp =lista.filter(value => {
            if((!value.fornecedor.nome.toLowerCase().indexOf(e.target.value.toLowerCase(), -1))){
                return value;
            }
        })
        setFornecedores(temp)
    }

    const columns = [
        {
            name: "Nome",
            selector: "fornecedor.nome",
            sortable: true
        },
        {
            name:"",
            cell:row=><Link to={"/fornecedor/" + row.fornecedor.id}><Button variant={"contained"} color={"primary"}>Ficha</Button></Link>

        },
        {
            name:"",
            cell:row=><Link to={"/fornecedor/editar/" + row.fornecedor.id}><Button variant={"contained"} color={"primary"}>Editar</Button></Link>
        }
    ];



    return (
        <Container component="main" maxWidth="md">
            <TextField label="Pesquisa" onChange={pesquisa}/>
            <FormControlLabel
                control={
                    <Switch
                        checked={inativos}
                        onChange={()=>setInativos(!inativos)}
                        name="checkedB"
                        color="primary"
                    />
                }
                label="Mostrar inativos"
            />
            <div className={classes.paper}>
                <DataTable
                    title="Fornecedores"
                    columns={columns}
                    data={fornecedores}
                    sortIcon={<SortIcon />}
                    pagination
                    selectableRowsComponent={Checkbox}
                    contextMessage={{
                        singular: 'artigo',
                        plural: 'artigos',
                        message: 'selecionada\\s' }}
                    noDataComponent={"Não foi encontrados clientes"}
                    progressPending={loading}
                    progressComponent={<CircularProgress />}
                    paginationComponentOptions={{
                        rowsPerPageText: 'Linhas por pagina:',
                        rangeSeparatorText: 'de',
                        noRowsPerPage: false,
                        selectAllRowsItem: false,
                        selectAllRowsItemText: 'Todas'
                    }}
                />
            </div>
        </Container>
    );
}
